/* global axios */
import ApiClient from '../ApiClient';

class AiAgentVersions extends ApiClient {
  constructor() {
    super('ai_agents/brains', { accountScoped: true });
  }

  get({ brainId }) {
    return axios.get(`${this.url}/${brainId}/versions`);
  }

  show({ brainId, id }) {
    return axios.get(`${this.url}/${brainId}/versions/${id}`);
  }
}

export default new AiAgentVersions();
